var _path, _rect, _rect2, _path2, _path3, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentSuccessIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 355,
    viewBox: "0 0 375 355",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187.5 355C291.053 355 375 343.139 375 328.508C375 313.878 291.053 302.017 187.5 302.017C83.9466 302.017 0 313.878 0 328.508C0 343.139 83.9466 355 187.5 355Z",
    fill: "#F5F5F5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 87.3691,
    width: 203.207,
    height: 335.357,
    rx: 14,
    fill: "#18BC46"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 95.2227,
    y: 6.86426,
    width: 187.5,
    height: 321.629,
    rx: 11,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M189.464 160.814C213.862 160.814 233.64 141.058 233.64 116.688C233.64 92.3183 213.862 72.5625 189.464 72.5625C165.067 72.5625 145.289 92.3183 145.289 116.688C145.289 141.058 165.067 160.814 189.464 160.814Z",
    fill: "white",
    stroke: "#45B549",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeDasharray: "7 7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M175.721 114.558L188.338 126.494L211.061 106.883",
    stroke: "#45B549",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 150.197,
    y: 0.000488281,
    width: 77.5524,
    height: 18.6309,
    rx: 6,
    fill: "#18BC46"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 167.867,
    y: 8.8252,
    width: 53.9921,
    height: 5.88345,
    rx: 2.94173,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 157.07,
    y: 8.8252,
    width: 5.89005,
    height: 5.88345,
    rx: 2.94173,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 160.012,
    y: 217.688,
    width: 106.021,
    height: 5.88345,
    rx: 2.94173,
    fill: "#DFE2ED"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 160.012,
    y: 228.475,
    width: 41.2304,
    height: 5.88345,
    rx: 2.94173,
    fill: "#DFE2ED"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 113.875,
    y: 214.746,
    width: 36.322,
    height: 22.5532,
    rx: 6,
    fill: "#DFE2ED"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 160.012,
    y: 252.008,
    width: 106.021,
    height: 5.88345,
    rx: 2.94173,
    fill: "#DFE2ED"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 160.012,
    y: 262.795,
    width: 41.2304,
    height: 5.88345,
    rx: 2.94173,
    fill: "#DFE2ED"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 113.875,
    y: 249.066,
    width: 36.322,
    height: 22.5532,
    rx: 6,
    fill: "#DFE2ED"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 160.012,
    y: 286.328,
    width: 106.021,
    height: 5.88345,
    rx: 2.94173,
    fill: "#DFE2ED"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 160.012,
    y: 297.115,
    width: 41.2304,
    height: 5.88345,
    rx: 2.94173,
    fill: "#DFE2ED"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 113.875,
    y: 283.387,
    width: 36.322,
    height: 22.5532,
    rx: 6,
    fill: "#DFE2ED"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 110.93,
    y: 37.2617,
    width: 119.764,
    height: 5.88345,
    rx: 2.94173,
    fill: "#DFE2ED"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 239.529,
    y: 37.2617,
    width: 27.4869,
    height: 5.88345,
    rx: 2.94173,
    fill: "#DFE2ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentSuccessIllustration);
export default __webpack_public_path__ + "static/media/PaymentSuccessIllustration.3743413ca810b3fd3a818b84a90e4084.svg";
export { ForwardRef as ReactComponent };